import React from 'react';

export default function Pipe() {
    return (
        <span className="css-fan">|</span>
    );
}
